<div class="dialogContainer">
  <div class="header">
    <h2>Line {{ entityLine.lineId }} Specifications</h2>
    <div class="subHeader">Model {{ entityLine.itemNumber }} &middot; Serial {{ entityLine.product }}</div>
  </div>
  <div class="content">
    @if (errorMessage()) {
      <div class="errorMessage">{{ errorMessage() }}</div>
    } @else if (!isBusy() && specifications().length === 0) {
      <div class="emptyMessage">No saved specifications were found for this unit.</div>
    } @else if (!isBusy()) {
      <table class="reportTable specTable">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell">Specification</td>
            <td class="tableCell headerCell centeredCell">Value</td>
          </tr>
        </thead>
        @for (specification of specifications(); track $index) {
          <tr>
            <td class="tableCell">{{ specification.name }}</td>
            <td class="tableCell">{{ specification.value }}</td>
          </tr>
        }
      </table>
    }
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="close()">Close</button>
    </span>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
